import * as React from 'react';
import { DialogActions, DialogContent, Grid } from '@mui/material';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import { useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { t } from 'i18next';
import { useAppDispatch } from '../../redux_store/reduxStore';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { BakeasyButtonClose, BakeasyButtonCreate } from '../../components/buttons/BakeasyButton';
import { addIngredient } from '../../redux_store/slices/ingredientsSlice';

export const AddIngredient = (props: any) => {
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [name, setName] = useState<string>('');

  function handleClose() {
    myContext.setDialog({ open: false });
    if (props?.onBack) {
      props?.onBack({ name });
    }
  }

  const checkValidity = (): boolean => {
    if (!name) {
      let msg = `${t('INGREDIENT_NAME_REQUIRED')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }
    return true;
  };

  async function onAddSubmit() {
    if (!checkValidity()) {
      return;
    }
    let payload = { ingredientName: name };
    await dispatch(addIngredient(payload));
    handleClose();
  }

  return (
    <>
      <DialogContent dividers>
        <Grid spacing={2} width={'30vw'} minWidth={'300px'}>
          <Grid item xs={12} sm={12}>
            <BakeasyTextField
              label={t('INGREDIENT_NAME')}
              placeHolder={t("ENTER_INGREDIENT_NAME")}
              type="text"
              name="name"
              value={name}
              required={true}
              onChange={(event: any) => {
                setName(event.target.value);
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ margin: 1 }}>
        <BakeasyButtonClose onClick={handleClose} />
        <BakeasyButtonCreate
          onClick={() => {
            onAddSubmit();
          }}
        />
      </DialogActions>
    </>
  );
};
